import { useMemo } from 'react'
import { Campaign } from '@/services/api/campaign'
import useInvestments from '@/services/hooks/useInvestments'
import usePayouts from '@/services/hooks/usePayouts'
import useUserIVAs from '@/services/hooks/useUserIVAs/useUserIVAs'
import useUserInvestedCampaigns from '@/services/hooks/useUserInvestedCampaigns'
import useUserPledges from '@/services/hooks/useUserPledges/useUserPledges'

export const useMyInvestmentsData = () => {
  const { investments = [], isLoading: investmentsLoading } = useInvestments()

  const { userPledges: pledges = [], isLoading: pledgesLoading } =
    useUserPledges()

  const { userInvestedCampaigns: campaigns = [], isLoading: campaignsLoading } =
    useUserInvestedCampaigns()

  const { IVAs = [], isLoading: IVAsLoading } = useUserIVAs()

  const { payouts = [], isLoading: payoutsLoading } = usePayouts()

  const validSortedInvestments = useMemo(
    () =>
      investments
        .filter((investment) => {
          const campaign = campaigns.find(
            (c) => c.slug === investment.campaign
          ) as Campaign

          // Might have gotten white-label filtered
          if (!campaign) return false

          // Only show incomplete investments if campaign is still funding
          return (
            investment.completed || campaign?.status === 'currently_funding'
          )
        })
        .sort(
          (a, b) =>
            new Date(b.closedAt || b.modified).getTime() -
            new Date(a.closedAt || a.modified).getTime()
        ),
    [investments, campaigns]
  )

  return {
    investments: validSortedInvestments,
    pledges: pledges.sort(
      (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
    ),
    campaigns,
    IVAs,
    payouts,
    isLoading:
      investmentsLoading ||
      campaignsLoading ||
      IVAsLoading ||
      pledgesLoading ||
      payoutsLoading,
  }
}

export default useMyInvestmentsData
